import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';

export default new class {
    constructor() {
    }
    async getNewsData(locale) {
        return  ServerRequestUtil.post('api/app/news/getNewsData', {locale: locale});
    }
}